import { ChinaFlagRounded as l, UkFlagRounded as a, SpainFlagRounded as e } from "./styles16.mjs";
const o = [
  {
    label: "Chinese",
    shortLabel: "CN",
    value: "cn",
    flag: l
  },
  {
    label: "English (US)",
    value: "en",
    flag: a
  },
  {
    label: "Spanish",
    value: "es",
    flag: e
  }
];
export {
  o as LANGUAGE_SELECT_OPTIONS
};
//# sourceMappingURL=constants19.mjs.map
